import { SharedModule } from '@shared/shared.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CoreModule } from '@core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { AttachmentsModule } from '../attachments/attachments.module';
import { AssignmentComponent } from './components/task-components/assignment/assignment.component';
import { DiscountComponent } from './components/task-components/discount/discount.component';
import { TaskSelectionChangeComponent } from './components/task-selection-change/task-selection-change.component';
import { TaskTypeDropdownComponent } from './components/task-type-dropdown/task-type-dropdown.component';
import { UIModule } from '@shared/modules/ui/ui.module';
import { DndModule } from 'ngx-drag-drop';
import { TaskShareModalComponent } from './components/task-share-modal/task-share-modal.component';
import { TaskSelectionV2ChangeComponent } from './components/task-selection-change-v2/task-selection-change-v2.component';
import { FormsV2Module } from '../forms-v2/forms-v2.module';

export const TASKS_COMPONENTS = [
  TaskTypeDropdownComponent,
  AssignmentComponent,
  DiscountComponent,
  TaskSelectionChangeComponent,
  TaskSelectionV2ChangeComponent,
  TaskShareModalComponent
];

export const TASKS_EXPORT = [DiscountComponent, TaskSelectionChangeComponent, TaskSelectionV2ChangeComponent];
export const TASKS_PROVIDERS = [];

export const TASK_MODULES = [
  CoreModule,
  SharedModule,
  TranslateModule,
  AttachmentsModule,
  DragDropModule,
  DndModule,
  UIModule,
  FormsV2Module
];
